<template>
  <router-view />
</template>
<script>
export default {
  name: "inventoryProducts",
};
</script>
